"use client"

import DomainsTable from "@/components/DomainsTable";
import { DomainSchema } from "@/schemas/domain.schema";
import { getNormalDomains } from "@/services/domains.service";
import { useEffect, useState } from "react";
import { z } from "zod";

export default function DomainsPage() {
  const [domains, setDomains] = useState<z.infer<typeof DomainSchema>[]>([]);

  const loadAllDomains = async () => {
    const domains = await getNormalDomains();
    setDomains(domains);
  };

  useEffect(() => {
    loadAllDomains();
  }, []);

  return (
    <DomainsTable domains={domains}/>
  );
}
